import emailWay from './email';
import phoneWay from './phone';
import selectWay from './select';
import thridWay from './third';
import emailForget from './email/forget';
import phoneForget from './phone/forget';
export default {
  name: 'mlogreg',
  props: {
    thirdHost: {
      type: String,
      default: ''
    },
    oldThirdHost: {
      type: String,
      default: ''
    },
    clientId: {
      type: String,
      default: ''
    },
    showContent: {
      type: Boolean,
      default: false
    },
    // inHome: { type: Function, default: () => {} },
    // updateUserInfo: { type: Function, default: () => {} },
    close: {
      type: Function,
      default: function _default() {}
    },
    success: {
      type: Function,
      default: function _default() {}
    },
    fail: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {
    'select-way': selectWay,
    'email-way': emailWay,
    'phone-way': phoneWay,
    'third-way': thridWay,
    'email-forget': emailForget,
    'phone-forget': phoneForget
  },
  data: function data() {
    return {
      wayType: '',
      isShowLogin: true,
      forgetState: '',
      loginName: '',
      itc: '',
      country: ''
    };
  },
  computed: {
    headState: function headState() {
      return this.wayType !== 'm-email' && this.wayType !== 'm-phone';
    }
  },
  methods: {
    showForgetHandle: function showForgetHandle(type, name, itc, country) {
      this.isShowLogin = false;
      this.forgetState = type;
      this.loginName = name;
      this.itc = itc;
      this.country = country;
    },
    selectWayHandle: function selectWayHandle(type, first) {
      this.isShowLogin = true;
      this.wayType = type;
      if (first) {
        this.wayType = '';
      }
    },
    back: function back() {
      if (this.headState) {
        // 关闭页面
        this.close();
      } else {
        var way = this.wayType.split('-')[1];
        var wayObj = this.$refs["".concat(way, "Way")];
        var rt = wayObj.regType;
        if (!this.isShowLogin) {
          this.isShowLogin = true;
        } else if (rt === 'input') {
          this.wayType = '';
          this.isShowLogin = true;
        } else if (rt === 'login' || rt === 'reg') {
          wayObj.regType = 'input';
        } else {
          this.wayType = '';
          this.isShowLogin = true;
        }
      }
    }
  },
  watch: {
    showContent: function showContent(val) {
      if (!val) {
        this.isShowLogin = true;
        this.wayType = '';
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};